import React from 'react';

import { IIcons } from '../interfaces/icons';
import { getColorHelper } from '../utils/getColorHelpers';

export function QuestionCircle({
  fillColor = 'black',
  colorWeight,
  size = '16',
  height,
  width,
  onClick,
  style,
  className,
}: IIcons) {
  const iconFill = getColorHelper(fillColor, colorWeight);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || size}
      height={height || size}
      fill="none"
      viewBox="0 0 16 16"
      onClick={onClick}
      style={style}
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
        fill={iconFill}
      />
      <path
        d="M5.255 5.786C5.25363 5.81829 5.25889 5.85053 5.27044 5.88072C5.28198 5.91091 5.29959 5.93841 5.32216 5.96155C5.34473 5.98468 5.3718 6.00296 5.4017 6.01524C5.43159 6.02753 5.46369 6.03357 5.496 6.033H6.321C6.459 6.033 6.569 5.92 6.587 5.783C6.677 5.127 7.127 4.649 7.929 4.649C8.615 4.649 9.243 4.992 9.243 5.817C9.243 6.452 8.869 6.744 8.278 7.188C7.605 7.677 7.072 8.248 7.11 9.175L7.113 9.392C7.11405 9.45761 7.14086 9.52017 7.18763 9.5662C7.2344 9.61222 7.29739 9.63801 7.363 9.638H8.174C8.24031 9.638 8.3039 9.61166 8.35078 9.56478C8.39766 9.51789 8.424 9.4543 8.424 9.388V9.283C8.424 8.565 8.697 8.356 9.434 7.797C10.043 7.334 10.678 6.82 10.678 5.741C10.678 4.23 9.402 3.5 8.005 3.5C6.738 3.5 5.35 4.09 5.255 5.786ZM6.812 11.549C6.812 12.082 7.237 12.476 7.822 12.476C8.431 12.476 8.85 12.082 8.85 11.549C8.85 10.997 8.43 10.609 7.821 10.609C7.237 10.609 6.812 10.997 6.812 11.549Z"
        fill={iconFill}
      />
    </svg>
  );
}
